import { applyMiddleware, compose, createStore } from "redux";
import { promiseMiddleware } from "@adobe/redux-saga-promise";
import createSagaMiddleware, { END } from "redux-saga";

import AdProReducer from "reducers";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";

export const history = createBrowserHistory();

export default function configureStore(preloadedState) {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    AdProReducer(history),
    preloadedState,
    compose(applyMiddleware(routerMiddleware(history), promiseMiddleware, sagaMiddleware)),
  );

  store.runSaga = sagaMiddleware.run;
  store.close = () => store.dispatch(END);
  return store;
}
